import { animate, stagger, createSpring } from 'animejs';

export default () => {
    animate('.home__heading h1', {
        translateX: [-100, 0],
        opacity: [0, 1],
        duration: 2040,
        delay: stagger(200),
        ease: createSpring({ mass: 1, stiffness: 50, damping: 10, velocity: 0 }),
    });
};
